import Vue from "vue";
import VueRouter from "vue-router";
import routes from "@/router/routes";

Vue.use(VueRouter);

const DEFAULT_TITLE = '株式会社Value';

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  // ページ遷移時は先頭へスクロール（ブラウザ戻る/進むは元の位置を復元、ハッシュはアンカーへ）
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (to.hash) {
      return {selector: to.hash};
    }
    return {x: 0, y: 0};
  },
});

router.afterEach((to, ) => {
  document.title = to.meta ? (to.meta.title || DEFAULT_TITLE) : DEFAULT_TITLE;
});

export default router;
